import React from "react";
import singleSpaReact from "single-spa-react";
import ReactDOM from "react-dom";

import { App } from "./app/App";


export const { bootstrap, mount, unmount } = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: App,
  errorBoundary: (err, info, props) => {

    // Customize the root error boundary for your microfrontend here.
    console.log('SSPA error:', err, info, props);

    return null as any;
  },
});
